export interface PurchaseOrderLineHeader {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderAndLineNo: string;
  sequence: number;
  status: string;
  contractNo: number;
  productType: string;
  productId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  supplierReference: string;
  orderLineReference: string;
  quantity: number;
  quantityReceived: number;
  unitOfMeasure: string;
  noOfItems: number;
  price: number;
  lineValue: number;
  urgent: string;
  deliveryDate: Date;
  canDelete: boolean;
  allocated: boolean;
  received: boolean;
  invoiced: boolean;
  productSpec: boolean;
  callOffReady: boolean;
  callOffRequested: boolean;
}
